import "../scss/semaphore.scss";

import u from "./includes/utils";


function updateElapsedTime() {
	const element = document.querySelector('[data-last-time]');
	if (!element) return;

	const lastTimeStr = element.getAttribute('data-last-time');
	if (!lastTimeStr) return;

	const [hours, minutes, seconds] = lastTimeStr.split(':').map(Number);

	const lastTime = new Date();
	lastTime.setHours(hours, minutes, seconds, 0);

	const now = new Date();
	if (lastTime > now) {
		lastTime.setDate(lastTime.getDate() - 1);
	}

	const elapsedMs = now - lastTime;
	const elapsedSeconds = Math.floor(elapsedMs / 1000);

	const h = Math.floor(elapsedSeconds / 3600);
	const m = Math.floor((elapsedSeconds % 3600) / 60);
	const s = elapsedSeconds % 60;

	const formattedTime = [h, m, s]
		.map(val => val.toString().padStart(2, '0'))
		.join(':');

	element.textContent = formattedTime;
}


u.documentReady(() => {
	document.body.classList.add("page-has-loaded");

	updateElapsedTime();
	setInterval(updateElapsedTime, 1000);

	if (document.body.classList.contains('presentation-mode')) {
		setInterval(() => {
			window.location.reload();
		}, 60000);
	} else {
		setInterval(() => {
			const notification = document.querySelector('.l-semaphore-page--notification');
			if (!notification) return;

			const currentCount = parseInt(notification.getAttribute('data-message-count'), 10) || 0;

			fetch('count/')
				.then(response => response.json())
				.then(data => {
					if (data.count > currentCount) {
						notification.classList.remove('is-hidden');
					}
				})
				.catch(error => {
					console.error('Error fetching message count:', error);
				});
		}, 30000);
	}
});
